import { config, dom, library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";

// Manually import CSS into stylesheet file for better CSP compatibility.
config.autoAddCss = false;

library.add(faInfoCircle, faMinusCircle, faPlusCircle, faSearch);

dom.watch();
